import ApplyNotarization from '@/views/apply/ApplyNotarization.vue';
import ApplySearch from '@/views/apply/ApplySearch.vue';
import ApplyDetail from '@/views/apply/ApplyDetail.vue';
import ApplySubject from '@/views/apply/ApplySubject.vue';
import ApplyMail from '@/views/apply/ApplyMail.vue';
import CompanySeller from '@/views/apply/CompanySeller.vue';
import CompanyBuyer from '@/views/apply/CompanyBuyer.vue';
import PersonSeller from '@/views/apply/PersonSeller.vue';
import PersonBuyer from '@/views/apply/PersonBuyer.vue';
export default [
    {
        path: '/apply',
        name: '订单列表',
        meta: {
            keepAlive: true,
            tab: {
                name: '订单',
                icon: 'icon icon-home',
                iconActive: 'icon icon-home1',
            }
        },
        component: ApplySearch
    },
    {
        path: '/apply/detail',
        name: '订单详情',
        component: ApplyDetail
    },
    {
        path: '/apply/subject',
        name: '标的物信息',
        component: ApplySubject
    },
    {
        path: '/apply/mail',
        name: '邮寄信息',
        component: ApplyMail
    },
    {
        path: '/apply/companyseller',
        name: '卖方单位',
        component: CompanySeller
    },
    {
        path: '/apply/companybuyer',
        name: '买方单位',
        component: CompanyBuyer
    },
    {
        path: '/apply/personseller',
        name: '卖方个人',
        component: PersonSeller
    },
    {
        path: '/apply/personbuyer',
        name: '买方个人',
        component: PersonBuyer
    },
    {
        path: '/apply/notarization',
        name: '公证书',
        component: ApplyNotarization
    }
]